<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <div class="mat-dialog-content__image">
      <img [src]="assetsUrl + '/images/cdt/icons/information.svg'" alt="" />
    </div>
    <div class="mat-dialog-content__title">
      <p>Verifica tu información</p>
    </div>
    <div class="mat-dialog-content__text">
      <p>
        Confirma que tus datos sean correctos.<br />Estos datos no podrán ser
        cambiados más adelante.
      </p>
    </div>

    <div class="additional-info">
      <ul>
        <li class="first">
          <strong>Correo electrónico</strong>
          <span class="email" [ngClass]="{ large: emailLarge }">{{
            data.email
          }}</span>
        </li>
        <li>
          <strong>Número de celular</strong> <span>{{ data.cellphone }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-dialog-close
    class="btn btn-degraded blue"
    type="button"
    (click)="onSubmit('continue')"
    id="confirm-form-user-dialog-button"
  >
    Continuar
  </button>
</div>
<div mat-dialog-actions>
  <button
    mat-dialog-close
    class="btn btn-degraded blue white"
    type="button"
    (click)="onSubmit('fixForm')"
    id="fix-form-user-dialog-button"
  >
    Corregir datos
  </button>
</div>
